import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box,
} from '@mui/material';

import { useNavigate, Link } from 'react-router-dom';

import DateFilter from '@inovua/reactdatagrid-community/DateFilter'

import CommonBreadcumbs from '../../../../components/common/CommonBreadcumbs';
import DataGridToolbar from '../../../../components/common/DataGridToolbar';
import DataGridTable from '../../../../components/common/DataGridTable';
import DataGridRowActionMenu from '../../../../components/common/DataGridRowActionMenu';
import { icons } from '../../../../components/common/CommonIcons';

import { useDataGridParams } from '../../../../hooks/useDataGridParams';
import { useAppContextFeatures } from '../../../../context/AppContext';
import { useDocuments, documentTypes, targetTypes } from '../../../../hooks/api/useDocuments';
import { useSystemPrompt } from '../../../../hooks/useSystemPrompt';
import { useSystemRoutes, routeTypes } from '../../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../../hooks/useSystemHead';

export default function PackingOrdersPage() {

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();
    const { list, remove } = useDocuments({ documentType: documentTypes.packingOrder });

    const { defineColumns, columns, filterValues, getRenderColumnLink, getRenderColumnBooleanDisplay } = useDataGridParams('id')
    const [ selectedIds, setSelectedIds ] = useState([])
    const [ refreshDataGrid, setRefreshDataGrid ] = useState(0)
    const { getLocationIds } = useAppContextFeatures();

    const gridRef = React.createRef();
    const { getRoute } = useSystemRoutes(routeTypes.admin);
    const { getHtmlHead } = useSystemHead(routeTypes.admin)

    const resetDataGridTableSelection = () => {
        setSelectedIds([])
    }

    useEffect(() => {

        setRefreshDataGrid(val => val+1)

    }, [getLocationIds])

    const fetchData = async (props) => {

        resetDataGridTableSelection();

        try{

            props.customFilterLocationEnable = true;
            props.customFilterLocationFields = ['location_id']

            const result = await list(props)

            return {
                data: result?.data?.documents,
                count: result?.data?.total
            }

        }catch(error){

            promptMessage(false, `Error getting results (${error?.message})`)
            
            return {
                data: [],
                count: 0
            }
        }  
        
    }

    useEffect (()=>{
        defineColumns ([
        { 
            name: 'doc_number', 
            header: 'Doc No', 
            renderValue: ({ value, cellProps }) => {

                let path = getRoute(`documents/packingOrder/view/${cellProps.data.id}`);

                return getRenderColumnLink(path, value)

            }
        },
        { 
            name: 'doc_date', header: 'Date'
        },
        { 
            name: 'location_name', header: 'Location'
        },
        ])
    })

    const filterValue = 
        [
            { name: 'doc_number', operator: 'eq', type: 'string', value: '' },
            { name: 'doc_date', operator: 'eq', type: 'string', value: '' },
            { name: 'location_name', operator: 'eq', type: 'string', value: '' },
        ];

    const handleDelete = async () => {

        try{

            let result = await remove({ ids: selectedIds, targetType: targetTypes.itemPacking })

            promptMessage(true, result?.message)
            setRefreshDataGrid(val => val+1)

        }catch(error){
            promptMessage(false, error?.message)
        }

    }

    return (
        <Box>
            {  
                getHtmlHead({ routeType: routeTypes.admin, title: headTitles.packingOrders })
            }

            <CommonBreadcumbs
                routeType={routeTypes.admin}
                pageTitle="Packing Orders"
                breadcrumbs={[
                    {
                        displayText: "Packing Orders",
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            <DataGridToolbar
                selectedRowCount={
                    selectedIds.length
                }
                mainMenus={[
                    {
                        // displayText: "New Packing Order",
                        displayIconName: icons.plus,
                        onClick: () => {

                            // navigate(getRoute("documents/packingOrder/new"));

                        }
                    },
                ]}
                // ]}
                actionOnClickRemove={handleDelete}
                actionMenus={[]}
            />

            <DataGridTable
                ref={gridRef}
                refresh={refreshDataGrid}
                fetchData={fetchData}
                dataGrid={{
                    idProperty: "id",
                    style: {
                        minHeight: 600
                    },
                    pageSizes: [20, 50, 100],
                    defaultLimit: 10,
                    defaultSkip: 0,
                    checkboxColumn: true,
                    columns,
                    defaultFilterValue: filterValue,
                    onSelectionChange: (items) => {
                        // console.log('items selected : ', items)
                        setSelectedIds(
                            items
                        )
                    }
                }}
                
            />

        </Box>
    )
}
